export default __webpack_public_path__ + "static/media/hoodie1-back.7614a35b.webp";